import React from 'react'
import './css/Aboutuscomp.css'
import bg1 from "../assets/studiobg1.png";
import bg2 from "../assets/studiobg2.png";

const Aboutuscomp = () => {
    return (
        <section className='aboutus-main-div'>
            <div className='aboutus-main-div-content'>
                <div className='aboutus-main-div-content1'>
                    <div className='aboutus-main-div-content1-content1'>
                        <img src={bg1} alt="Dhiman Wood Works craftsmanship" />
                    </div>
                    <div className='aboutus-main-div-content1-content2'>
                        <img src={bg2} alt="Dhiman premium woodworking" />
                    </div>
                </div>
                <div className='studios-container-main-content2'>
                    <h2 className='studios-heading-small'>
                        At Dhiman Wood Works, we transform your vision into timeless wooden masterpieces. Our expert craftsmen work closely with each client, ensuring every project reflects the perfect blend of traditional craftsmanship and modern design.
                    </h2>
                    <div className='studios-container-main-content2-content1-paras'>
                        <p className='paragraph'>
                            Dhiman Wood Works stands as a premier name in custom woodworking and interior solutions. Our legacy of excellence spans residential and commercial projects, specializing in bespoke furniture, custom cabinetry, and architectural woodwork. Each piece we create tells a story of precision, passion, and unparalleled craftsmanship.

                            Led by master craftsmen, our team combines generations of woodworking expertise with contemporary design approaches. We take pride in delivering exceptional wooden installations that not only meet but exceed our clients' expectations, creating spaces that inspire and endure.
                        </p>
                        <button className='button-89-2'>Explore Our Legacy</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Aboutuscomp
